import React from 'react';
import { PaymentSpringFormFields } from '../../../types/shared/PaymentSpring';
import { NumberInput } from '../../uiold';
import {
  Box,
  Button,
  FormLabel,
  GridItem,
  SimpleGrid,
  Text,
} from '../../../core-ui';

export type PaymentFormProps = {
  formattedPrice: string;
  totalPrice: string;
  onSubmit: () => void;
  handleFormChange: (formFields: PaymentSpringFormFields) => void;
  formFields: PaymentSpringFormFields;
  onAltPaymentClick: () => void;
};

export default function PaymentSpringForm(props: PaymentFormProps) {
  let {
    formattedPrice,
    onSubmit,
    formFields,
    handleFormChange,
    onAltPaymentClick,
  } = props;

  let handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    onSubmit();
  };

  return (
    <Box as="form" onSubmit={handleSubmit} className="std-form embedded-form">
      <SimpleGrid columns={1} gap={2}>
        <GridItem>
          <Text>
            {t(
              'To pay {formattedPrice} by credit card, use the following form.',
              { formattedPrice },
            )}
          </Text>
        </GridItem>
        <GridItem>
          <Button isFullWidth onClick={onAltPaymentClick}>
            {t('Pay with ACH instead')}
          </Button>
        </GridItem>
        <GridItem>
          <FormLabel>{t('Card number')}</FormLabel>
          <NumberInput
            onValueChange={(valueAsNumber, valueAsString) => {
              let cardNumber = valueAsString.replace(/\D/g, '');
              handleFormChange({ ...formFields, card_number: cardNumber });
            }}
            placeholder={t('Card number')}
            value={formFields.card_number}
          />
        </GridItem>
        <GridItem>
          <FormLabel>{t('Expiration date')}</FormLabel>
          <SimpleGrid columns={2} gap={2}>
            <GridItem colSpan={1}>
              <NumberInput
                onValueChange={(valueAsNumber, valueAsString) => {
                  let expMonth = valueAsString.replace(/\D/g, '').slice(0, 2);
                  handleFormChange({
                    ...formFields,
                    card_exp_month: expMonth,
                  });
                }}
                placeholder={t('MM')}
                value={formFields.card_exp_month}
              />
            </GridItem>
            <GridItem colSpan={1}>
              <NumberInput
                onValueChange={(valueAsNumber, valueAsString) => {
                  let expYear = valueAsString.replace(/\D/g, '').slice(0, 4);
                  handleFormChange({
                    ...formFields,
                    card_exp_year: expYear,
                  });
                }}
                placeholder={t('YYYY')}
                value={formFields.card_exp_year}
              />
            </GridItem>
          </SimpleGrid>
        </GridItem>
        <GridItem>
          <FormLabel>{t('CVV')}</FormLabel>
          <NumberInput
            onValueChange={(valueAsNumber, valueAsString) => {
              let cvv = valueAsString.replace(/\D/g, '').slice(0, 4);
              handleFormChange({
                ...formFields,
                cvv,
              });
            }}
            placeholder={t('CVV')}
            value={formFields.cvv}
          />
        </GridItem>
        <GridItem>
          <Button onClick={handleSubmit} variant="primary" width="100%">
            {t('Submit')}
          </Button>
        </GridItem>
      </SimpleGrid>
    </Box>
  );
}
